import React, { useState, useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import {
  Select,
  FormControl,
  InputLabel,
  Button,
  OutlinedInput,
  MenuItem,
  TextField,
  makeStyles,
  createMuiTheme,
  MuiThemeProvider,
  Tooltip,
  IconButton,
  CircularProgress,
} from "@material-ui/core";
import { DoubleArrow, ArrowBack, Info } from "@material-ui/icons";
import { objects } from "../../../utils/constants";
import bg from "../../../images/bg-logo.jpg";
import { useHistory } from "react-router-dom";
import { LanguageSelectorDropdown } from "../../../components/Language/LanguageSelectorDropdown";
import {
  getTaxesObject,
  getTaxesPayer,
} from "../../../../services/taxes.service";

const theme = createMuiTheme({
  palette: {
    // primary: 'purple',
    secondary: {
      // main: "#1A66AC"
      main: "rgb(100, 38, 187)",
    },
    // error: 'red',
  },
});

let finalObjects = [];
let stakeholdersId = [];

const SelectIndustryCategory = ({
  industryCategories,
  person,
  handleIndustryCategoryChange,
  selectedIndustryCategory,
  selectedObjectName,
  handleObjectNameChange,
  selectedCertificate,
  handleSubmit,
  handleBackButton,
  registredStakeholders,
  voens,
  registeredObjects,
  newObjectName,
  newObjectCode,
  setnewObjectName,
  setnewObjectCode,
}) => {
  console.log("[SELECT INDUSTRY DEBUG] Component initialized", {
    industryCategoriesCount: industryCategories?.length,
    hasSelectedCertificate: !!selectedCertificate,
    certificateVoen: selectedCertificate?.voen,
    certificateName: selectedCertificate?.structureName,
    voensCount: voens?.length,
    registredStakeholdersCount: registredStakeholders?.length,
    registeredObjectsCount: registeredObjects?.length,
    selectedIndustryCategory: selectedIndustryCategory?.name,
    personName: person?.name
  });
  const intl = useIntl();
  const classes = useStyle();
  const industryInputLabel = React.useRef(null);
  const [industryLabelWidth, setIndustryLabelWidth] = useState(0);
  const [addObject, setAddObject] = useState(voens.length ? false : true);
  const [data, setData] = useState([]);
  const [taxPayerObjData, setTaxPayerObjData] = useState([]);
  const [taxPayerInfo, setTaxPayerInfo] = useState({});
  const [detailEr, setDetailEr] = useState("");
  const [taxPayerObjLoading, setTaxPayerObjLoading] = useState(false);
  const [taxPayerInfoLoading, setTaxPayerInfoLoading] = useState(false);
  const history = useHistory();

  const findRegistredObjects = () => {
    console.log("[SELECT INDUSTRY DEBUG] findRegistredObjects: Starting", {
      stakeholdersCount: registredStakeholders?.length
    });
    registredStakeholders.map((stakeholders) => {
      stakeholdersId.push(stakeholders._id);
      let eachFilters = objects.filter(
        (object) => object.objectCode === stakeholders.objectCode
      );
      finalObjects = [...finalObjects, ...eachFilters];
    });
    console.log("[SELECT INDUSTRY DEBUG] findRegistredObjects: Completed", {
      finalObjectsCount: finalObjects.length,
      stakeholderIdsCount: stakeholdersId.length
    });
  };

  const mappedObject = () => {
    console.log("[SELECT INDUSTRY DEBUG] mappedObject: Starting");
    findRegistredObjects();
    let matchedCount = 0;
    for (let i = 0; i < objects.length; i++) {
      for (let j = 0; j < finalObjects.length; j++) {
        if (objects[i].objectCode === finalObjects[j].objectCode) {
          objects[i].stateObject.stakeholder_id = stakeholdersId[j];
          objects[i].stateObject.status = true;
          matchedCount++;
          continue;
        }
      }
    }
    console.log("[SELECT INDUSTRY DEBUG] mappedObject: Completed", {
      matchedObjectsCount: matchedCount
    });
  };

  const changeRegistrationMethod = () => {
    console.log("[SELECT INDUSTRY DEBUG] changeRegistrationMethod: Toggling registration method", {
      currentAddObject: addObject,
      willSetTo: !addObject
    });
    handleObjectNameChange("");
    !addObject ? setAddObject(true) : setAddObject(false);
  };

  useEffect(() => {
    setIndustryLabelWidth(industryInputLabel?.current?.offsetWidth);
    registredStakeholders?.length > 0 && mappedObject();
  }, [registredStakeholders]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    console.log("[SELECT INDUSTRY DEBUG] getData: Starting...");
    const selectedVoen = localStorage.getItem("selectedVoen");
    const localData = localStorage.getItem("signinStatusData");
    let parsedData = localData ? JSON.parse(localData) : null;
    console.log("[SELECT INDUSTRY DEBUG] getData: Retrieved data from localStorage", {
      hasSelectedVoen: !!selectedVoen,
      selectedVoen,
      hasLocalData: !!localData,
      hasContainer: !!parsedData?.container
    });
    if (selectedVoen && localData && parsedData.container) {
      let encoded = window.btoa(parsedData?.container);
      const obj = {
        base64Content: parsedData.container,
        fileType: "adoc",
        voenOrPin: selectedVoen,
      };
      console.log("[SELECT INDUSTRY DEBUG] getData: Fetching tax object data...");
      try {
        setTaxPayerObjLoading(true);
        let taxesObjData = await getTaxesObject(obj);
        console.log("[SELECT INDUSTRY DEBUG] getData: Tax object data received", {
          hasTourismDTOList: !!taxesObjData?.data?.tourismDTOList,
          tourismListLength: taxesObjData?.data?.tourismDTOList?.length,
          hasInvalidParams: taxesObjData?.data?.invalidParams != null,
          detail: taxesObjData?.data?.detail
        });
        if (taxesObjData?.data?.invalidParams == null) {
          setDetailEr(taxesObjData.data.detail);
        }

        if (taxesObjData?.data?.tourismDTOList) {
          setTaxPayerObjData(taxesObjData.data.tourismDTOList);
        }
        setTaxPayerObjLoading(false);
      } catch (error) {
        setTaxPayerObjLoading(false);
        console.error("[SELECT INDUSTRY DEBUG] getData: getTaxesObject error", {
          error: error?.message,
          response: error?.response?.data,
          status: error?.response?.status
        });
      }

      console.log("[SELECT INDUSTRY DEBUG] getData: Fetching tax payer info...");
      try {
        setTaxPayerInfoLoading(true);
        let taxesPayerData = await getTaxesPayer(obj);
        console.log("[SELECT INDUSTRY DEBUG] getData: Tax payer info received", {
          hasLegalAddressData: !!taxesPayerData?.data?.legalPayerEnt?.legalAddressRelationEnt?.addressEnt
        });
        if (
          taxesPayerData?.data?.legalPayerEnt?.legalAddressRelationEnt
            ?.addressEnt
        ) {
          setTaxPayerInfo(
            taxesPayerData.data.legalPayerEnt.legalAddressRelationEnt.addressEnt
          );
        }
        setTaxPayerInfoLoading(false);
      } catch (error) {
        setTaxPayerInfoLoading(false);
        console.error("[SELECT INDUSTRY DEBUG] getData: getTaxesPayer error", {
          error: error?.message,
          response: error?.response?.data,
          status: error?.response?.status
        });
      }
    } else {
      console.log("[SELECT INDUSTRY DEBUG] getData: Missing required data", {
        hasSelectedVoen: !!selectedVoen,
        hasLocalData: !!localData,
        hasContainer: !!parsedData?.container
      });
    }
  };

  // useEffect(() => {
  //   console.log("SelectIndustryCategory: voens", voens);
  //   console.log("SelectIndustryCategory: registeredObjects", registeredObjects);
  //   console.log(
  //     "SelectIndustryCategory: registredStakeholders",
  //     registredStakeholders
  //   );
  // }, [registredStakeholders, voens, registeredObjects]);

  return (
    <div className={`${classes.cardW} card card-custom card-stretch gutter-b`}>
      <div className={`card-body ${classes.cardBody}`}>
        <div className="d-flex align-items-center">
          <img src={bg} alt="" width="100%" />
        </div>

        {taxPayerObjLoading ? (
          <CircularProgress
            style={{ marginTop: "24%", marginRight: "15%", color: "#543295" }}
            color="secondary"
          />
        ) : (
          <>
            {" "}
            {detailEr ? (
              <div style={{ marginTop: "21%" }}>
                <p style={{ color: "red", fontWeight: "bold" }}>{detailEr} </p>
                <Button
                  style={{
                    textTransform: "capitalize",
                    backgroundColor: "rgb(100, 38, 187)",
                    color: "#fff",
                    width: "160px",
                    height: "45px",
                  }}
                  variant="outlined"
                  color="default"
                  size="small"
                >
                  <FormattedMessage id="button.back" />
                </Button>{" "}
              </div>
            ) : (
              <div className="w-50 d-flex flex-column justify-content-center">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h3 className="text-muted">
                    <FormattedMessage id="choose_industry_category" />
                  </h3>
                  <div className="d-flex align-items-center">
                    <LanguageSelectorDropdown />
                  </div>
                </div>

                {selectedCertificate?.structureName ? (
                  <TextField
                    id="voen"
                    style={{ margin: "10px 0", width: "100%" }}
                    variant="outlined"
                    readOnly
                    size="small"
                    value={selectedCertificate?.structureName}
                  />
                ) : (
                  <TextField
                    fullWidth
                    variant="outlined"
                    id="outlined-password-input"
                    type="text"
                    value={`${person?.name} ${person?.surname} ${person?.patronymic}`}
                    autoComplete="current-password"
                  />
                )}

                {addObject === true || !registeredObjects?.length ? (
                  <div>
                    {industryCategories?.length ? (
                      <div className="d-flex align-items-center">
                        <FormControl
                          size="small"
                          variant="outlined"
                          style={{ margin: "10px 0", width: "100%" }}
                        >
                          <InputLabel
                            ref={industryInputLabel}
                            htmlFor="industry_category"
                          >
                            <FormattedMessage id="industry_category" />
                          </InputLabel>
                          <Select
                            value={selectedIndustryCategory}
                            onChange={(e) => {
                              handleIndustryCategoryChange(e.target.value);
                            }}
                            input={
                              <OutlinedInput
                                labelWidth={industryLabelWidth}
                                name="industryCategory"
                                id="outlined-industry_category-simple"
                              />
                            }
                          >
                            {industryCategories?.map((cat) => (
                              <MenuItem key={cat._id} value={cat}>
                                {cat?.name[intl.locale]}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <Tooltip
                          placement="right"
                          title={
                            <span style={{ fontSize: "13px" }}>
                              <FormattedMessage id="reg.tooltip.industry" />
                            </span>
                          }
                        >
                          <IconButton>
                            <Info />
                          </IconButton>
                        </Tooltip>
                      </div>
                    ) : null}

                    {voens.length ? (
                      <div>
                        {taxPayerObjData.length > 0 ? (
                          <div>
                            <div className="d-flex align-items-center">
                              <FormControl
                                size="small"
                                variant="outlined"
                                style={{ margin: "10px 0", width: "100%" }}
                                className="d-flex flex-column"
                              >
                                <InputLabel htmlFor="object_name">
                                  <FormattedMessage id="key_object_name" />
                                </InputLabel>
                                <Select
                                  value={selectedObjectName}
                                  onChange={(e) => {
                                    handleObjectNameChange(e.target.value);
                                    let object = taxPayerObjData.find(
                                      (v) => v.name === e.target.value
                                    );

                                    if (object?.code) {
                                      let splitedCode = object.code.split(
                                        "-"
                                      )[1];

                                      let x = splitedCode
                                        .replace(/[^0-9.]/g, "")
                                        .replace(/(\..*?)\..*/g, "$1");
                                      setnewObjectCode(x);
                                    }
                                  }}
                                  input={
                                    <OutlinedInput
                                      labelWidth={industryLabelWidth}
                                      name="objectName"
                                      id="outlined-object-name-simple"
                                    />
                                  }
                                >
                                  {taxPayerObjData?.map((v) => (
                                    <MenuItem key={v.name} value={v.name}>
                                      {v?.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                              <Tooltip
                                placement="right"
                                title={
                                  <span style={{ fontSize: "13px" }}>
                                    <FormattedMessage id="reg.tooltip.objectname" />
                                  </span>
                                }
                              >
                                <IconButton>
                                  <Info />
                                </IconButton>
                              </Tooltip>
                            </div>

                            <div className="d-flex align-items-center">
                              <TextField
                                fullWidth
                                type="text"
                                className="mt-3"
                                value={newObjectCode}
                                label={
                                  <FormattedMessage id="key_object_code" />
                                }
                                size="small"
                                variant="outlined"
                              />
                              <Tooltip
                                placement="right"
                                title={
                                  <span style={{ fontSize: "13px" }}>
                                    <FormattedMessage id="reg.tooltip.objectcode" />
                                  </span>
                                }
                              >
                                <IconButton>
                                  <Info />
                                </IconButton>
                              </Tooltip>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <div className="d-flex align-items-center">
                              <TextField
                                fullWidth
                                value={newObjectName}
                                label={
                                  <FormattedMessage id="key_object_name" />
                                }
                                size="small"
                                variant="outlined"
                                onChange={(e) =>
                                  setnewObjectName(e.target.value)
                                }
                              />

                              <Tooltip
                                placement="right"
                                title={
                                  <span style={{ fontSize: "13px" }}>
                                    <FormattedMessage id="reg.tooltip.objectname" />
                                  </span>
                                }
                              >
                                <IconButton>
                                  <Info />
                                </IconButton>
                              </Tooltip>
                            </div>

                            <div className="d-flex align-items-center">
                              <TextField
                                fullWidth
                                type="text"
                                className="mt-3"
                                value={newObjectCode}
                                label={
                                  <FormattedMessage id="key_object_code" />
                                }
                                size="small"
                                variant="outlined"
                                onChange={(e) =>
                                  setnewObjectCode(
                                    e.target.value
                                      .replace(/[^0-9.]/g, "")
                                      .replace(/(\..*?)\..*/g, "$1")
                                  )
                                }
                              />
                              <Tooltip
                                placement="right"
                                title={
                                  <span style={{ fontSize: "13px" }}>
                                    <FormattedMessage id="reg.tooltip.objectcode" />
                                  </span>
                                }
                              >
                                <IconButton>
                                  <Info />
                                </IconButton>
                              </Tooltip>
                            </div>
                          </div>
                        )}
                      </div>
                    ) : null}
                  </div>
                ) : null}

                {addObject === false && registeredObjects?.length ? (
                  <FormControl
                    size="small"
                    variant="outlined"
                    style={{ width: "100%" }}
                  >
                    <InputLabel
                      ref={industryInputLabel}
                      htmlFor="industry_category"
                    >
                      <FormattedMessage id="key_object_names" />
                    </InputLabel>
                    <Select
                      value={selectedObjectName}
                      onChange={(e) => {
                        handleObjectNameChange(e.target.value);
                      }}
                      input={
                        <OutlinedInput
                          labelWidth={industryLabelWidth}
                          name="objectName"
                          id="outlined-industry_category-simple"
                        />
                      }
                    >
                      {registeredObjects?.map((obj) => (
                        <MenuItem
                          key={obj?.objectCode}
                          value={obj}
                          style={{ width: "330px" }}
                        >
                          <span>{obj.brandName}</span>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                ) : null}

                {voens.length && registeredObjects?.length ? (
                  <Button
                    className="mt-4"
                    variant="contained"
                    size="small"
                    onClick={() => changeRegistrationMethod()}
                  >
                    {!addObject ? (
                      <FormattedMessage id="button.add_object" />
                    ) : (
                      <FormattedMessage id="button.choose_object" />
                    )}
                  </Button>
                ) : null}

                <div
                  className={`card-toolbar d-flex ${
                    !voens.length
                      ? "justify-content-center"
                      : "justify-content-between"
                  } mt-8`}
                >
                  {voens.length > 0 && (
                    <Button
                      style={{
                        textTransform: "capitalize",
                        backgroundColor: "rgb(100, 38, 187)",
                        color: "#fff",
                        width: "160px",
                        height: "45px",
                      }}
                      variant="outlined"
                      color="default"
                      size="small"
                      onClick={handleBackButton}
                    >
                      <FormattedMessage id="button.back" />
                    </Button>
                  )}
                  <MuiThemeProvider theme={theme}>
                    {selectedObjectName !== "" ? (
                      <Button
                        style={{
                          textTransform: "capitalize",
                          width: "160px",
                          color: "#fff",
                          height: "45px",
                          marginLeft: "10px",
                        }}
                        variant="contained"
                        color="secondary"
                        size="small"
                        className={classes.secondaryMUI}
                        onClick={handleSubmit}
                        disabled={selectedObjectName == "" ? true : false}
                      >
                        {selectedObjectName?.stateObject?.status ? (
                          <FormattedMessage id="button.continue" />
                        ) : (
                          <FormattedMessage id="button.continue_gradge" />
                        )}
                      </Button>
                    ) : (
                      <Button
                        style={{
                          textTransform: "capitalize",
                          width: "160px",
                          color: "#fff",
                          height: "45px",
                          marginLeft: "10px",
                        }}
                        variant="contained"
                        color="secondary"
                        size="small"
                        className={classes.secondaryMUI}
                        onClick={handleSubmit}
                        disabled={
                          selectedIndustryCategory === "" ||
                          (voens?.length && newObjectCode.length <= 2)
                            ? true
                            : false
                        }
                      >
                        <FormattedMessage id="button.continue" />
                      </Button>
                    )}
                  </MuiThemeProvider>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SelectIndustryCategory;

const useStyle = makeStyles({
  cardW: {
    width: "828px",
    margin: "auto",
  },
  secondaryMUI: {
    "&: .MuiButton-containedSecondary": {
      // backgroundColor: "#1A66AC",
      backgroundColor: "rgb(100, 38, 187)",
    },
  },
  cardBody: {
    display: "flex",
    height: "400px",
    paddingTop: "40px",
    justifyContent: "space-between",
  },
});
